import { GET_ORDERS, SET_TOTAL_ACCEPTED_ORDERS, SET_TOTAL_COMPLETED_ORDERS, SET_TOTAL_IN_PROGRESS_ORDERS, SET_TOTAL_ORDERS, SET_TOTAL_PENDING_ORDERS, SET_TOTAL_REJECTED_ORDERS } from "../utilities/constants";
const initialState = {
  orders: [],
  count: 0,
  pendingOrders: 0,
  acceptedOrders: 0,
  startedOrders: 0,
  completedOrders: 0,
  rejectedOrders: 0
};
export default function orderReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ORDERS:
      return {
        ...state,
        orders: [...action.payload],
      };
    case SET_TOTAL_ORDERS:
      return { ...state, count: action.payload };
    case SET_TOTAL_PENDING_ORDERS:
      return { ...state, pendingOrders: action.payload };
    case SET_TOTAL_ACCEPTED_ORDERS:
      return { ...state, acceptedOrders: action.payload };
    case SET_TOTAL_IN_PROGRESS_ORDERS:
      return { ...state, startedOrders: action.payload };
    case SET_TOTAL_COMPLETED_ORDERS:
      return { ...state, completedOrders: action.payload };
    case SET_TOTAL_REJECTED_ORDERS:
      return { ...state, rejectedOrders: action.payload };
    default:
      return state;
  }
}
